import { render } from "./alumnity.vue?vue&type=template&id=40425987"
import script from "./alumnity.vue?vue&type=script&lang=js"
export * from "./alumnity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__